import { baseUrl } from '@/shared/constants'
import axios from 'axios'

export const postStartTask = async (token: string, task_id: number) => {
  const response = await axios.post(
    `${baseUrl}/tasks/check-task`,
    {
      task_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )

  return response.data
}


export const getTasks = async (token: string) => {
  const response = await axios.get(`${baseUrl}/tasks/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response.data
}



export const postClaimTaskRewrd = async (token: string, task_id: number) => {
  const response = await axios.post(
    `${baseUrl}/tasks/claim`,
    {
      task_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )

  return response.data
}